// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css"; // If you have CSS
import App from "./App";

// Wait for DOM to be ready
document.addEventListener("DOMContentLoaded", () => {
	// Find the root element
	const container = document.getElementById("root");

	// Check if container exists
	if (!container) {
		console.error(
			'Root element not found! Make sure your HTML has <div id="root"></div>',
		);
		return;
	}

	// Create React root and render app
	const root = createRoot(container);

	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
});

// Alternative: If you want to ensure DOM is ready without event listener
// const container = document.getElementById('root');
// if (container) {
//   const root = createRoot(container);
//   root.render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   );
// } else {
//   console.error('Failed to find root element');
// }
